export default __webpack_public_path__ + "static/media/format_list_numbered.2dfa0ea0.svg";